<template>
  <div class="detail page-shell">
    <banner title="新闻详情" eyebrow="News Detail" :desc="detail.title" />

    <article class="section-wrap detail-card">
      <img v-lazy="detail.Img" :alt="detail.title" />
      <div class="detail-card__content">
        <span>{{ detail.CreateTime }}</span>
        <h1>{{ detail.title }}</h1>
        <p>{{ detail.content }}</p>
        <router-link class="back-link" to="/news">返回新闻资讯</router-link>
      </div>
    </article>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import site from "../static/siteData";

export default {
  name: "NewsDetails",
  components: {
    Banner
  },
  computed: {
    detail() {
      const params = this.$route.params || {};
      const fallback = site.news[0];
      return {
        title: params.title || params.Title || fallback.title,
        Img: params.Img || fallback.Img,
        CreateTime: params.CreateTime || fallback.CreateTime,
        content: params.content || params.Content || fallback.content
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.detail {
  min-height: 100vh;
}

.detail-card {
  margin-top: 72px;
  margin-bottom: 92px;
  overflow: hidden;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(16, 68, 130, 0.1);
}

.detail-card > img {
  width: 100%;
  max-height: 560px;
  object-fit: cover;
  display: block;
}

.detail-card__content {
  width: min(820px, calc(100% - 40px));
  margin: 0 auto;
  padding: 46px 0 58px;
}

.detail-card__content span {
  color: #1677ff;
  font-size: 13px;
  font-weight: 900;
}

h1 {
  margin-top: 14px;
  color: #071a35;
  font-size: 34px;
  line-height: 1.3;
}

p {
  margin-top: 24px;
  color: #42566f;
  font-size: 17px;
  line-height: 2;
}

.back-link {
  display: inline-flex;
  margin-top: 34px;
  color: #1677ff;
  font-weight: 800;
}

@media (max-width: 640px) {
  .detail-card {
    margin-top: 48px;
    margin-bottom: 68px;
  }

  h1 {
    font-size: 28px;
  }
}
</style>
